import { useQuery } from '@tanstack/react-query';
import { getUsers } from '../services/userService';
import { queryKeys } from '../constants/queryKeys';

const PAGE_SIZE = 20;

// Fetch paginated user list — returns the raw envelope { data, totalPages, ... }
export const useUsers = (page = 1, search = '') => {
  return useQuery({
    queryKey: queryKeys.users.list(page, search),
    queryFn: () => getUsers({ page, pageSize: PAGE_SIZE, search: search || undefined }),
  });
};
